import { render } from "./LegendPopup.vue?vue&type=template&id=4e8c0104"
import script from "./LegendPopup.vue?vue&type=script&lang=js"
export * from "./LegendPopup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\paintcare\\pcsitelocator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__